import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "change-password-form password-form-weblib",
  "data-qe-id": "form-change-password"
}
const _hoisted_2 = {
  key: 0,
  class: "form-message form-success"
}
const _hoisted_3 = { class: "headline" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icf-ok" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "form-message form-error"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "icf-warning" }, null, -1)
const _hoisted_7 = { class: "form-group-child" }

import PasswordCurrentInput from '@/components/PasswordCurrentInput.vue'
import PasswordInput from '@/components/PasswordInput.vue'
import PasswordRepeatInput from '@/components/PasswordRepeatInput.vue'
import { ERROR_CODES } from '@/model/ERROR_CODES'
import { Password, PasswordCurrent, PasswordRepeat } from '@/model/Password'
import { setupComponentI18n } from '@gd/i18n'
import { GD, STORE_NAME, Storage, User } from '@gd/storage'
import { Ref, onMounted, ref } from 'vue'
import events from '@gd/event-bus'

const changePasswordUrl = '/gd/rest/playerProfile/changePassword'

export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePasswordForm',
  setup(__props) {

setupComponentI18n()

const passwordCurrentNode = ref(null)
const passwordNode = ref(null)
const passwordRepeatNode = ref(null)

const changeSuccessMessage = ref(false)
const errorCode: Ref<'main' | ''> = ref('')
const userName = ref('')

const passwordCurrent: Ref<PasswordCurrent> = ref({
  value: '',
  valid: false,
  errorCode: undefined,
  length: false,
  wrong: false,
})

const passwordRepeat: Ref<PasswordRepeat> = ref({
  value: '',
  valid: false,
  errorCode: undefined,
  length: false,
  identically: false,
})

const password: Ref<Password> = ref({
  value: '',
  valid: false,
  errorCode: undefined,
  length: false,
  numbers: false,
  specialChars: false,
  lowerUpperCase: false,
  scoreOk: false,
  sameAsOldPassword: false,
  sameAsUserName: false,
  similarToUserName: false,
  sameAsEmail: false,
  score: 0,
})

const enablePasswordRepeatValidation = ref(false)
const enablePasswordValidation = ref(false)
const enablePasswordCurrentValidation = ref(false)

const buttonProgress = ref(false)

onMounted(() => {
  const user: User = new Storage().read(STORE_NAME.USER).name
  userName.value = user.name
  changeSuccessMessage.value = false
  errorCode.value = ''
})

const action = () => {
  enablePasswordCurrentValidation.value = true
  enablePasswordValidation.value = true
  enablePasswordRepeatValidation.value = true
  changeSuccessMessage.value = false
  errorCode.value = ''

  if (passwordCurrent.value.valid && password.value.valid && passwordRepeat.value.valid) {
    buttonProgress.value = true

    const request: GD_playerProfile.ChangePasswordData = {
      currentPassword: passwordCurrent.value.value,
      newPassword1: password.value.value,
      newPassword2: passwordRepeat.value.value,
    }
    // TODO fetch
    fetch(changePasswordUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    })
      .then((res) => res.json())
      .then((response: GD_playerProfile.ChangePasswordResponse) => {
        if (response.errors && response.errors.length > 0) {
          if (response.errors.indexOf('unknownError') > -1) {
            errorCode.value = 'main'
          }
          if (response.errors.indexOf('passwordWrong') > -1) {
            passwordCurrent.value.errorCode = ERROR_CODES.passWrong
          }
          if (response.errors.indexOf('passwordSameAsCurrent') > -1) {
            password.value.errorCode = ERROR_CODES.passwordEqualsPassword
          }
          if (response.errors.indexOf('passwordInvalidFormat') > -1) {
            password.value.errorCode = ERROR_CODES.passInvalid
          }
          if (response.errors.indexOf('passwordEqualsCommonName') > -1) {
            password.value.errorCode = ERROR_CODES.passEqualsName
          }
          if (response.errors.indexOf('passwordSimilarCommonName') > -1) {
            password.value.errorCode = ERROR_CODES.passSimilarName
          }
          if (response.errors.indexOf('passwordEqualsEmail') > -1) {
            password.value.errorCode = ERROR_CODES.passwordEqualsEmail
          }
          if (response.errors.indexOf('passwordNotSame') > -1) {
            password.value.errorCode = ERROR_CODES.passNotSame
          }
        } else {
          // Blur the text-inputs
          passwordCurrentNode.value.blur()
          passwordNode.value.blur()
          passwordRepeatNode.value.blur()

          changeSuccessMessage.value = true
          resetInputs()
        }
        buttonProgress.value = false
      })
      .catch(() => {
        buttonProgress.value = false
      })
  }
}

const resetInputs = () => {
  passwordNode.value.reset()

  enablePasswordCurrentValidation.value = false
  enablePasswordValidation.value = false
  enablePasswordRepeatValidation.value = false

  passwordCurrent.value = {
    value: '',
    valid: false,
    errorCode: undefined,
    length: false,
    wrong: false,
  }

  passwordRepeat.value = {
    value: '',
    valid: false,
    errorCode: undefined,
    length: false,
    identically: false,
  }

  errorCode.value = ''
}

const preventSubmit = (event: Event) => {
  event.preventDefault()
  event.stopPropagation()
}

const onHelpshift = () => {
  const storageGD: GD = new Storage().read(STORE_NAME.GD)
  events.$emit('helpshift-article', { name: 'passwordhelp', lang: storageGD.viewLang, disableLinks: false })
}

return (_ctx: any,_cache: any) => {
  const _component_t_button = _resolveComponent("t-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "form-gouping",
      onSubmit: _withModifiers(action, ["prevent"])
    }, [
      _createVNode(PasswordCurrentInput, {
        ref_key: "passwordCurrentNode",
        ref: passwordCurrentNode,
        validate: enablePasswordCurrentValidation.value,
        modelValue: passwordCurrent.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((passwordCurrent).value = $event)),
        onFocusCapture: _cache[1] || (_cache[1] = ($event: any) => (changeSuccessMessage.value = false)),
        onReset: _cache[2] || (_cache[2] = ($event: any) => (enablePasswordCurrentValidation.value = false))
      }, null, 8, ["validate", "modelValue"]),
      _createVNode(PasswordInput, {
        ref_key: "passwordNode",
        ref: passwordNode,
        name: userName.value,
        "current-password": passwordCurrent.value.value,
        validate: enablePasswordValidation.value,
        modelValue: password.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((password).value = $event)),
        onReset: _cache[4] || (_cache[4] = ($event: any) => (enablePasswordValidation.value = false)),
        onFocusCapture: _cache[5] || (_cache[5] = ($event: any) => (changeSuccessMessage.value = false)),
        onHelpshift: onHelpshift,
        newPasswordText: true
      }, null, 8, ["name", "current-password", "validate", "modelValue"]),
      _createVNode(PasswordRepeatInput, {
        ref_key: "passwordRepeatNode",
        ref: passwordRepeatNode,
        password: password.value.value,
        validate: enablePasswordRepeatValidation.value,
        modelValue: passwordRepeat.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((passwordRepeat).value = $event)),
        onFocusCapture: _cache[7] || (_cache[7] = ($event: any) => (changeSuccessMessage.value = false)),
        onReset: _cache[8] || (_cache[8] = ($event: any) => (enablePasswordRepeatValidation.value = false))
      }, null, 8, ["password", "validate", "modelValue"]),
      _createVNode(_Transition, { name: "grow" }, {
        default: _withCtx(() => [
          (changeSuccessMessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('pfwChangePassword.main.change_success')), 1)
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('pfwChangePassword.main.hint')), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (errorCode.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`pfwChangePassword.error.${errorCode.value}`)), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: "t-button-group",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (preventSubmit($event)))
        }, [
          _createVNode(_component_t_button, {
            onClick: action,
            progress: buttonProgress.value,
            midBlue: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('pfwChangePassword.main.button')), 1)
            ]),
            _: 1
          }, 8, ["progress"])
        ])
      ])
    ], 32)
  ]))
}
}

})